// extracted by mini-css-extract-plugin
module.exports = {"container":"e_zp","placeholder":"e_Ap","embed":"e_Bp"};